import styled from "styled-components";

export const ThemeTogglerWrapper = styled.div`
  width: 4rem;
  height: 2rem;
  border-radius: 2.5rem;
  display: flex;
  background-color: #eff3f8;
  background-color: ${(p) =>
    p.isActive ? "rgba(34, 118, 227, 0.4)" : "#eff3f8"};
`;

interface NotchProps {
  readonly isActive?: boolean;
}

export const Notch = styled.div<NotchProps>`
  height: 2rem;
  width: 2rem;
  cursor: pointer;
  border-radius: 50%;
  box-shadow: 0 0.1rem 0.1rem 0 rgba(0, 0, 0, 0.24),
    0 0 0.1rem 0 rgba(0, 0, 0, 0.12);
  background-color: ${(p) => (p.isActive ? "#2276e3" : "#9aaabf")};
  transition: transform 0.1s linear;
  transform: translate(${(p) => (p.isActive ? "2rem" : "0.1rem")});
`;
